import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Game from './pages/Game';
import Imprint from './pages/legal/Imprint';
import Privacy from './pages/legal/Privacy';
import AdminLogs from './pages/AdminLogs';
import BetaLogin from './pages/BetaLogin';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import NotFound from './pages/NotFound';
import { AuthGuard } from './components/auth/AuthGuard';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/play/login" element={<BetaLogin />} />
      <Route
        path="/play"
        element={
          <AuthGuard>
            <Game />
          </AuthGuard>
        }
      />
      <Route path="/legal/imprint" element={<Imprint />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/logs" element={<AdminLogs />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
